import { gql } from "@apollo/client";

export const UPDATE_EMAIL = gql`
  mutation Mutation($email: String) {
    updateEmail(email: $email)
  }
`;
